export default "__VITE_ASSET__370673d2__"